module.exports = __webpack_public_path__ + "static/media/main idea.817cc1b5.mp3";